module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommend"
  }, [_c('mt-header', {
    attrs: {
      "title": "推荐的专家"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', [(_vm.project) ? _c('div', {
    staticClass: "pjtTitle"
  }, [_c('div', {
    staticClass: "bgimg",
    class: {
      'zhaomu': _vm.project.status == 4, 'close': _vm.project.status == 5, 'jinxing': _vm.project.status == 7, 'over': _vm.project.status == 8, 'hezuo': _vm.project.status == 6, 'pingjia': _vm.project.status == 9, 'shenhe': _vm.project.status == 1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.project.createTime)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list_wrap"
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop,
      "bottom-all-loaded": _vm.allLoaded,
      "auto-fill": false
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.recommendLists), function(recommend, index) {
    return _c('div', {
      key: index,
      staticClass: "list",
      staticStyle: {
        "padding": "0 10px 10px",
        "background-color": "#fff",
        "border-bottom": "1px solid #ccc",
        "margin-bottom": "6px"
      }
    }, [_c('div', {
      staticClass: "jumpBtn",
      on: {
        "click": function($event) {
          return _vm.toPersonDetail(recommend.personalInformation[0].account)
        }
      }
    }, [_vm._v("主页>")]), _vm._v(" "), _c('div', {
      staticClass: "info_wrap"
    }, [_c('div', {
      staticClass: "portrait"
    }, [_c('img', {
      attrs: {
        "src": _vm.httpUrl + recommend.personalInformation[0].photo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', [_c('div', {
      staticClass: "line_one"
    }, [_c('span', [_vm._v(_vm._s(recommend.personalInformation[0].account.name))]), _vm._v(" "), (recommend.personalInformation[0].sex == 0) ? _c('icon', {
      attrs: {
        "name": "venus"
      }
    }) : _c('icon', {
      attrs: {
        "name": "mars"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(recommend.personalInformation[0].position))])], 1), _vm._v(" "), _c('div', {
      staticClass: "line_two"
    }, [_c('span', [_vm._v(_vm._s(recommend.personalInformation[0].cityName))]), _c('span', [_vm._v(_vm._s(recommend.personalInformation[0].enterTypeName))]), _c('span', [_vm._v(_vm._s(recommend.personalInformation[0].experienceName))]), _c('span', [_vm._v(_vm._s(recommend.salary) + "元/天")]), _c('span', [_vm._v(_vm._s(recommend.turnover) + "单")])])]), _vm._v(" "), _c('div', [(recommend.personalInformation[0].positionTypeName != null) ? _c('div', {
      staticClass: "labels"
    }, _vm._l((recommend.personalInformation[0].positionTypeName.split(",")), function(skillsList, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(skillsList))])
    }), 0) : _vm._e(), _vm._v(" "), (recommend.star == 5) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('span', [_vm._v("5分")])], 1) : (recommend.star == 4.5) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-half-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("4.5分")])], 1) : (recommend.star == 4) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("4分")])], 1) : (recommend.star == 3.5) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-half-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("3.5分")])], 1) : (recommend.star == 3) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("3分")])], 1) : (recommend.star == 2.5) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-half-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("2.5分")])], 1) : (recommend.star == 2) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("2分")])], 1) : (recommend.star == 1.5) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-half-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("1.5分")])], 1) : (recommend.star == 1) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("1分")])], 1) : (recommend.star == 0.5) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star-half-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("0.5分")])], 1) : (recommend.star == 0) ? _c('div', {
      staticClass: "stars"
    }, [_c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "star-o"
      }
    }), _vm._v(" "), _c('span', [_vm._v("暂无评分")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rate"
    }, [_c('p', [_vm._v("准时率 "), _c('span', [_vm._v(_vm._s(recommend.punctuality) + "%")])]), _vm._v(" "), _c('p', [_vm._v("完成质量 "), _c('span', [_vm._v(_vm._s(recommend.quality) + "%")])]), _vm._v(" "), _c('p', [_vm._v("满意度 "), _c('span', [_vm._v(_vm._s(recommend.satisfaction) + "%")])])]), _vm._v(" "), (recommend.personalInformation[0].skills != null) ? _c('div', {
      staticClass: "skill"
    }, _vm._l((recommend.personalInformation[0].skills.split("@")), function(skillsList, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(skillsList))])
    }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "introduce"
    }, [_c('p', [_vm._v("个人简介")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(recommend.personalInformation[0].aboutMe))])]), _vm._v(" "), _c('div', {
      staticClass: "btns"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toHireDetail(recommend.personalInformation[0].account)
        }
      }
    }, [_vm._v("雇佣专家")]), _vm._v(" "), (false) ? _c('button', {
      attrs: {
        "type": "button"
      }
    }, [_vm._v("发送消息")]) : _vm._e()])])
  }), 0)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ad45c73","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/recommendPeople.vue
// module id = 1285
// module chunks = 1